import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminDashboard from './AdminDashboard';
import TeacherDashboard from './TeacherDashboard';
import ParentDashboard from './ParentDashboard';
import StudentDashboard from './StudentDashboard';
import './AdminDashboard.css';
import './TeacherDashboard.css';
import './ParentDashboard.css';
import './StudentDashboard.css';

const Dashboard: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <div className="loading">Loading...</div>;
  }

  // Route to specific dashboard based on user type
  if (user.userType === 'admin') {
    return <AdminDashboard />;
  }

  if (user.userType === 'teacher') {
    return <TeacherDashboard />;
  }

  if (user.userType === 'parent') {
    return <ParentDashboard />;
  }

  if (user.userType === 'student') {
    return <StudentDashboard />;
  }

  // For now, show basic dashboard for other roles
  return (
    <div className="container">
      <div className="card">
        <h2>Welcome to the Dashboard</h2>
        <div style={{ marginBottom: '20px' }}>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Username:</strong> {user.username}</p>
          <p><strong>User Type:</strong> 
            <span className={`user-type-badge ${user.userType}`} style={{ marginLeft: '10px' }}>
              {user.userType}
            </span>
          </p>
        </div>
        
        <div>
          <h3>Dashboard Functions</h3>
          <p>Your personalized dashboard is being prepared.</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
